import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Masterlist } from '../../models/masterlist';

@Injectable()
export class FirebaseProvider {
  masterlistCollection: AngularFirestoreCollection<Masterlist>;
  masterlistDoc: AngularFirestoreDocument<Masterlist>;
  masterlistProducts: Observable<Masterlist[]>;
  masterlistProduct: Observable<Masterlist>;

  constructor(private afs: AngularFirestore) {
    console.log("Hello FirebaseProvider Provider");
    this.masterlistCollection = this.afs.collection('masterlist', ref => ref.orderBy('model', 'asc'));
  }

  getMasterlist(): Observable<Masterlist[]> {
    this.masterlistProducts = this.masterlistCollection.snapshotChanges()
      .map(changes => {
        return changes.map(action => {
          const data = action.payload.doc.data() as Masterlist;
          data.id = action.payload.doc.id;
          // console.log(data);
          return data;
        });
      });
    return this.masterlistProducts;
  }
}
// var data = querySnapshot.docs.map(function(documentSnapshot) {
//   return documentSnapshot.data();
// });



// WEBPACK FOOTER //
// ./src/providers/firebase/firebase.ts